export default __webpack_public_path__ + "static/media/img-4.84553c01.jpg";